export default $axios => ({
  login({ email }) {
    return $axios.post('/api/login', { email });
  },
  logout() {
    return $axios.post('/api/logout');
  }
});
